import { EnvConfig } from '@config';
import { subHours } from 'date-fns';
import { useCallback } from 'react';
import { useFetch } from 'services/networking/useFetch';
import { DataConsistencyDTO } from 'types/dataConsistency';
import { WellboreDataIntermittenceDTO } from 'types/dataIntermittenceDto';
import { WellboreOutlierDTO } from 'types/outlierDto';

// TODO: Once the merge of the microservices is finished, rename / merge this
const dataQualityApiBaseUrl = EnvConfig.drillx_so_api_url || '';

const useFetchDataQualityByWellboreEndpoint = <ResponseType>(endpoint: string) =>
  useFetch<ResponseType>(dataQualityApiBaseUrl + endpoint);

export const useGetDataQualityByWellbore = (wellboreId: string) => {
  const { doFetch, error, isLoading, responseBody } =
    useFetchDataQualityByWellboreEndpoint<WellboreDataIntermittenceDTO>(
      `/data-holes/${wellboreId}`,
    );

  return {
    dataHoleError: error,
    dataHole: responseBody,
    isLoadingDataHole: isLoading,
    doFetchDataHoleByWellbore: doFetch,
  };
};

export const useGetOutliersByWellbore = (wellboreId: string) => {
  const { doFetch, error, isLoading, responseBody } =
    useFetchDataQualityByWellboreEndpoint<WellboreOutlierDTO>(`/outliers/${wellboreId}`);

  return {
    outlierError: error,
    doFetchOutliersByWellbore: doFetch,
    outlier: responseBody,
    isLoadingOutlier: isLoading,
  };
};

export const useGetDataConsistencyByWellbore = (wellboreId: string) => {
  const { doFetch, error, isLoading, responseBody } =
    useFetchDataQualityByWellboreEndpoint<DataConsistencyDTO>(`/data-consistency/${wellboreId}`);

  const doFetchDataConsistencyByWellbore = useCallback(() => {
    const now = new Date();
    const twoHoursAgo = subHours(now, 2);

    doFetch({ queryParams: { startDatetime: twoHoursAgo, endDatetime: now } });
  }, [doFetch]);

  return {
    dataConsistencyError: error,
    dataConsistency: responseBody,
    isLoadingDataConsistency: isLoading,
    doFetchDataConsistencyByWellbore,
  };
};
